module.exports = __webpack_public_path__ + "img/canbadge-round-57mm-asa_comp_line.6d81cdba.png";